import { render, staticRenderFns } from "./ShopGrade.vue?vue&type=template&id=2f241fa8&scoped=true"
import script from "./ShopGrade.vue?vue&type=script&lang=js"
export * from "./ShopGrade.vue?vue&type=script&lang=js"
import style0 from "./ShopGrade.vue?vue&type=style&index=0&id=2f241fa8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f241fa8",
  null
  
)

export default component.exports